import TableCard from 'components/organisms/Admin/Vehicle/TableCard'
import React from 'react'

const Vehicle: React.VFC = () => {
  return <TableCard />
}

export default Vehicle
